<template>
  <div class="container-fluid">
    <Breadcrumb :values="{ Home: '/', Search: '/search', [studyGroup ? studyGroup.name : 'Study']: ''}"></Breadcrumb>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">Files related to the study</div>
          <div class="card-body">
            <div v-if="studyGroup && studyGroup.children && studyGroup.children.length">
              <h4>{{ studyGroup.name || `Study group containing ${metadata.study_info.c_mi_number.value} study` }}</h4>
              <hr/>
              <Folder
                v-for="(child, i) in studyGroup.children"
                :key="i"
                :structure="child"
                :title="child.name"
                :depth="0"
                @refresh="studyGroupGet"
              />
            </div>
            <p v-else>No files</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Breadcrumb from '../components/shared/Breadcrumb'
// import FileList from '../components/FileStructure/FileList'
import Folder from '../components/FileStructure/Folder'
import generalActions from '../store/modules/general/actionTypes'
import studiesActions from '../store/modules/studies/actionTypes'

export default {
  name: 'FileStructure',
  components: { Breadcrumb, Folder },
  data () {
    return {
      studyGroup: null,
      alert: {
        type: '',
        icon: '',
        text: '',
        isVisible: false
      }
    }
  },
  methods: {
    ...mapActions({
      getRelatedFiles: studiesActions.FETCH_RELATED_STUDY_FILES,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),

    // Take the backend tree and clean up nested duplicate folders like Results/Results
    buildTree (data) {
    // Wrap whatever we got in a root node
      const root = Array.isArray(data)
        ? { name: 'Study group', type: 'directory', children: data }
        : data || { name: 'Study group', type: 'directory', children: [] }

      const dedupeNestedDirs = (node) => {
        if (!node || node.type !== 'directory' || !Array.isArray(node.children)) {
          return node
        }

        // First, recursively process children
        const children = node.children.map(child => dedupeNestedDirs(child))

        let newNode = { ...node, children }

        // If this directory has a single child directory with the same name,
        // flatten it: Results -> Results -> data_files  =>  Results -> data_files
        if (
          newNode.children.length === 1 &&
        newNode.children[0].type === 'directory' &&
        newNode.children[0].name === newNode.name
        ) {
          const onlyChild = newNode.children[0]
          newNode = {
            ...onlyChild,
            name: newNode.name // same name anyway, but explicit
          }
        }

        return newNode
      }

      return dedupeNestedDirs(root)
    },

    async studyGroupGet () {
      this.toggleLoading(true)
      const rawData = await this.getRelatedFiles(this.id)

      // rawData is already a tree (directories + files + children),
      // we just wrap + clean it up
      this.studyGroup = this.buildTree(rawData)

      console.log('Tree studyGroup:', this.studyGroup)
      this.toggleLoading(false)
    }
  },
  async mounted () {
    this.id = this.$route.params.id
    this.toggleLoading(true)
    await this.studyGroupGet()
    this.toggleLoading(false)
  }

}
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>
